import React, { useEffect, useState, Suspense, lazy } from "react";
import "./App.css";
import Navbar from './components/Navbar';
import axios from "axios";
import CacheBuster from 'react-cache-buster';
import MediaQuery from "react-responsive";
import appversion from '../package.json';
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import { CookieSetting } from "cookiesetting-component";

const Header = lazy(() => import("./components/Header"));
const EventMemories = lazy(() => import("./components/EventMemories"));
const Body = lazy(() => import("./components/Body"));

const Footer = lazy(() => import("./components/Footer"));
// import "@fontsource/poppins";

function App() {
  const appVersion = appversion.version;
  const [links, setLinks] = useState(null); // Set initial state as null
  const [showOtherComponents, setShowOtherComponents] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 10) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the scroll listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array ensures the effect runs only once, like componentDidMount

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);
  return (
    <>
     <CacheBuster
      currentVersion={appVersion}
      isEnabled ={true}
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      metaFileDirectory={'.'}
    >
      {links ? (
    <>
      <Navbar />
      <Suspense fallback={<div />}>
        <Header links={links.current} />
      </Suspense>
      <MediaQuery minWidth={992}>
      <Suspense fallback={<div />}>
        <EventMemories />
      </Suspense>
      {showOtherComponents && (
        <>
      <Suspense fallback={<div />}>
        <Body links={links.current}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />       
      </Suspense>
      </> )} 
      </MediaQuery>
      <MediaQuery maxWidth={991}>
      {showOtherComponents && (
        <>
         <Suspense fallback={<div />}>
        <EventMemories />
      </Suspense>
      <Suspense fallback={<div />}>
        <Body links={links.current}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      </> )}
      </MediaQuery>
      </>
      ) : (
      <div>Loading...</div>
    )}
     <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
      </CacheBuster>
    </>
  );
}

export default App;
